import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Orders() {
  const { user, loading: authLoading } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (authLoading) return;
    if (!user) { navigate("/"); return; }
    (async () => {
      try {
        const { data } = await api.get("/orders");
        setOrders(data.orders);
      } finally {
        setLoading(false);
      }
    })();
  }, [user, authLoading, navigate]);

  return (
    <main data-testid="orders-page" className="max-w-5xl mx-auto px-6 md:px-10 py-14 md:py-20">
      <span className="font-label text-xs text-[#1A6B2E]">Your history</span>
      <h1 className="font-display text-5xl md:text-6xl mt-3 leading-[0.95] tracking-tighter">My orders.</h1>

      {loading ? (
        <p className="mt-10 text-[#4E5C4F]">Loading…</p>
      ) : orders.length === 0 ? (
        <div className="chop-card chop-shadow p-10 mt-10 text-center">
          <p className="text-[#4E5C4F]">Nothing here yet.</p>
          <Link to="/menu" className="btn-primary inline-block mt-5 rounded-full px-6 py-3 text-sm font-semibold">
            Chop something
          </Link>
        </div>
      ) : (
        <div className="mt-10 space-y-4">
          {orders.map((o) => (
            <div key={o.order_id} data-testid={`order-${o.order_id}`} className="chop-card chop-shadow p-6 md:p-7 flex flex-wrap items-center gap-6 justify-between">
              <div>
                <p className="font-label text-[10px] text-[#4E5C4F]">{o.order_id}</p>
                <p className="font-display text-2xl mt-1">
                  {o.items.slice(0, 2).map((i) => `${i.quantity}× ${i.name}`).join(", ")}
                  {o.items.length > 2 && ` + ${o.items.length - 2} more`}
                </p>
                <p className="text-sm text-[#4E5C4F] mt-1">
                  {o.delivery_date} · {o.time_slot} · {o.city}
                </p>
              </div>
              <div className="text-right">
                <p className="font-display text-2xl">${o.total.toFixed(2)}</p>
                <span
                  className={`inline-block mt-1 rounded-full px-3 py-1 text-[11px] font-label ${
                    o.payment_status === "paid"
                      ? "bg-[#1A6B2E]/10 text-[#1A6B2E]"
                      : "bg-[#D02030]/15 text-[#E29A26]"
                  }`}
                >
                  {o.payment_status}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}
